import { Container, Grid, Paper, Typography } from '@mui/material'
import useStyles from '../styles/styles'
import Reveal from './Reveal'

const skills = ['HTML & CSS', 'JavaScript', 'Python', 'SQL', 'GraphQL', 'Node.js', 'React', 'Django & DRF', 'Flask']

const About = () => {
  const classes = useStyles()
  return (
    <section id="about" className={`${classes.section} ${classes.alternateSection}`}>
      <Container className={classes.content}>
        <Reveal>
          <header className={classes.sectionHeader}>
            <Typography className={classes.eyebrow}>01 / About</Typography>
            <Typography component="h2" className={classes.sectionTitle}>Ideas &amp; Code</Typography>
          </header>
          <Typography className={classes.bodyCopy}>
            As a full-stack software engineer, I focus on building reliable backend systems and clean, well-crafted interfaces that work together to deliver seamless user experiences. I've worked on a wide range of products, from an online auction platform and a secure note-taking application to an AI workforce system with scheduled execution and USDC payments.
          </Typography>
        </Reveal>
        <Grid container spacing={2} className={classes.skillGrid}>
          {skills.map((skill, index) => (
            <Grid key={skill} item xs={6} sm={4} md={3}>
              <Reveal delay={index * 35}><Paper className={classes.skill}>{skill}</Paper></Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  )
}

export default About
